import React, { ReactElement } from "react";
import { SpecificatieOverwaardeHoofstuk, Overwaarde } from "../../../../../.generated/rapportage/rapportagetypes";
import { Column } from "../../../components/BaseTable";
import Heading from "../../../components/Heading";
import { Paragraph } from "../../../components/Paragraph";
import Table from "../../../components/Table";
import "./overwaarde-specificatie.scss";

type OverwaardespecificatieProps = {
  specificatieOverwaarde: SpecificatieOverwaardeHoofstuk;
};

const overwaardeTable = (
  overwaarde: Overwaarde
): ReactElement => {
  const overwaardeOrRestschuld = overwaarde.totaalOverwaarde > 0 ? "Overwaarde" : "Restschuld";
  const columns: Column[] = [
    {
      header: "dummy",
      accessor: ()=> null
    }
  ];

  if (overwaarde.verkoopprijs !== 0 && overwaarde.verkoopprijs !== null) {
    columns.push({
      header: "Verkoopprijs",
      accessor: (row: Overwaarde) => row.verkoopprijs,
      dataType: "currency"
    });
  } 

  if (overwaarde.verkoopkosten !== 0 && overwaarde.verkoopkosten !== null) {
    columns.push({
      header: "Verkoopkosten",
      accessor: (row: Overwaarde) => row.verkoopkosten,
      dataType: "currency"
    });
  }

  if (overwaarde.percentageEigendom !== 0 && overwaarde.percentageEigendom !== null) {
    columns.push({
      header: "Percentage eigendom",
      accessor: (row: Overwaarde) => row.percentageEigendom,
      dataType: "percentage"
    });
  }

  if (overwaarde.nettoOpbrengst !== 0 && overwaarde.nettoOpbrengst !== null) {
    columns.push({
      header: "Netto opbrengst",
      accessor: (row: Overwaarde) => row.nettoOpbrengst,
      dataType: "currency"
    });
  }

  if (overwaarde.restantSchuld !== 0 && overwaarde.restantSchuld !== null) {
    columns.push({
      header: "Restant schuld box 1",
      accessor: (row: Overwaarde) => row.restantSchuld,
      dataType: "currency"
    });
  }

  if (overwaarde.vervreemdingssaldo !== 0 && overwaarde.vervreemdingssaldo !== null) {
    columns.push({
      header: "Vervreemdingssaldo",
      accessor: (row: Overwaarde) => row.vervreemdingssaldo,
      dataType: "currency"
    });
  }

  if (overwaarde.restantSchuldBox3 !== 0 && overwaarde.restantSchuldBox3 !== null) {
    columns.push({
      header: "Restant schuld box 3",
      accessor: (row: Overwaarde) => row.restantSchuldBox3,
      dataType: "currency"
    });
  }

  columns.push({
    header: `Totaal ${overwaardeOrRestschuld}`,
    accessor: (row: Overwaarde) => overwaardeOrRestschuld === "Overwaarde" ? row.totaalOverwaarde : row.totaalOverwaarde * -1,
    dataType: "currency",
    style: "font-weight: bold;"
  });

  const data: (Overwaarde & { label: string })[] = [{ ...overwaarde, label: "Waarde" }];
  const random = Math.random().toString(20).substring(2, 7);

  return (
    <Table
    rotate
    autoAlignCurrency
    columns={columns}
    data={data}
    id={`overwaarde-table-${random}`}
    className="labels-right break-avoid overwaarde-table"
    showHeader={false}
  />
  );
};

export const OverwaardeSpecificatieChapter = ({
  specificatieOverwaarde,
}: OverwaardespecificatieProps): ReactElement => {
  return (
    <div className="break-avoid">  
      {specificatieOverwaarde.titel && (
        <Heading
          text={`${specificatieOverwaarde.titel}`}
          level={2}
        />
      )}

      <Paragraph paragraaf={specificatieOverwaarde?.paragrafen?.p3040701}></Paragraph>

      {specificatieOverwaarde.overwaarde?.map((overwaarde: Overwaarde, index: number) => (
        <React.Fragment key={`overwaarde-${index}`}>
          {overwaardeTable(overwaarde)}
        </React.Fragment>
      ))}
      <br/>
    </div>
  );
};
